import Button from "@set-product/core/button/Button";
import React, { useEffect, useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";
import Select from "react-select";
import SVGCross from "components/_common/icons/tool/SVGCross";
import SVGItem from "components/_common/icons/tool/SVGItem";
import SVGCancel from "components/_common/icons/tool/SVGCancel";
import SVGTo from "components/_common/icons/tool/SVGTo";
import classNames from "classnames";
import clsx from "clsx";
import {
	clearIndicatorStyles,
	controlStyles,
	dropdownIndicatorStyles,
	menuStyles,
	multiValueStyles,
	optionStyles,
	placeholderStyles,
} from "redux/app/feedback/utils";
import toolActions from "redux/app/tool/actions";
import toolSelectors from "redux/app/tool/selectors";
import {
	getTenantsOptionList,
	getVesselsOptionList,
} from "redux/app/tool/utils";
import { IOption } from "redux/app/feedback/@types";
import { CONFIG_TABS } from "redux/app/tool/constants";
import { IConfigListItem } from "redux/app/tool/@types";
import { historyActions } from "redux/_core/history";
import { rootRoutes } from "routes";

// const groupStore: Record<
// 	string,
// 	{ _id: string; name: string; vesselList: IOption[] }
// > = {
// 	group1: {
// 		_id: "group1",
// 		name: "Group 1",
// 		vesselList: [
// 			{
// 				label: "VesselLink",
// 				value: "0205783724abe541179e0cde9901e889",
// 			},
// 			{
// 				label: "POSSM",
// 				value: "0205783724abe541179e0cde99027937",
// 			},
// 			{
// 				label: "PM Crown",
// 				value: "0bca4e1cb64eaae0e7c7ef4e1284efff",
// 			},
// 			{
// 				label: "Sun Flyte",
// 				value: "0bca4e1cb64eaae0e7c7ef4e12853a0e",
// 			},
// 			{
// 				label: "EPS Dev",
// 				value: "199e2190-888e-11ec-8797-77ddb80128b6",
// 			},
// 		],
// 	},
// 	group2: {
// 		_id: "group2",
// 		name: "Group 2",
// 		vesselList: [
// 			{
// 				label: "VesselLink",
// 				value: "0205783724abe541179e0cde9901e889",
// 			},
// 			{
// 				label: "POSSM",
// 				value: "0205783724abe541179e0cde99027937",
// 			},
// 			{
// 				label: "PM Crown",
// 				value: "0bca4e1cb64eaae0e7c7ef4e1284efff",
// 			},
// 			{
// 				label: "Sun Flyte",
// 				value: "0bca4e1cb64eaae0e7c7ef4e12853a0e",
// 			},
// 			{
// 				label: "EPS Dev",
// 				value: "199e2190-888e-11ec-8797-77ddb80128b6",
// 			},
// 		],
// 	},
// };

type OwnProps = {};
type ConfigCopyProps = PropsFromRedux & OwnProps;
function ConfigCopy(props: ConfigCopyProps) {
	const {
		tenants,
		vessels,
		selectedTenantOption,
		selectedVesselOptions,
		jobToLoadVesselSpecificToTenant,
		currentVesselDetails,
		configIdToBeCopied,
		configList,
		selectedItems,
		errorMessage,
		jobToCopyConfig,
		selectedGroupOption,
		groupList,
	} = props;
	const tenantOptions = useMemo(
		() => getTenantsOptionList(tenants),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[tenants.ids]
	);
	const vesselsOptions = useMemo(
		() => getVesselsOptionList(vessels),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[vessels.ids]
	);

	const groupOptions = groupList?.ids?.map((groupId) => {
		const group = groupList.byIds[groupId];
		return {
			label: group?.groupName,
			value: groupId,
		};
	});

	useEffect(() => {
		const tenantId = selectedTenantOption?.value;
		if (tenantId) {
			props.loadTenantSpecificVesselsList(tenantId);
			props.loadGroupsList(selectedTenantOption?.value);
		}
		props.setVessels(undefined);
		props.setGroupOption(undefined);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTenantOption?.value]);

	useEffect(() => {
		return () => {
			props.setTenant(undefined);
			props.setVessels(undefined);
			props.setActionConfigId("");
			// props.setSelectedItems([])
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const itemsToBeCopied = useMemo(() => {
		let itemsToBeCopied = [];
		if (selectedItems.length) {
			selectedItems.forEach((id) => {
				if (id in configList.byIds) itemsToBeCopied.push(configList.byIds[id]);
			});
		} else {
			if (configIdToBeCopied in configList.byIds) {
				const config = configList.byIds[configIdToBeCopied];
				itemsToBeCopied.push(config);
			}
		}
		return itemsToBeCopied;

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedItems, configList.ids, configIdToBeCopied]);

	return (
		<>
			<div className="h-full max-h-[calc(90vh)]  overflow-y-auto bg-white rounded-lg font-redhat-text">
				<div className="flex justify-between items-center py-2.5 px-4 border-[#C8C7C7] border-b">
					<div>
						<h2 className="text-2xl font-medium mb-0">Copy </h2>
						<p className="m-0 text-sm">from {currentVesselDetails?.label}</p>
						{errorMessage && (
							<span className="text-xs text-red-500">{errorMessage}</span>
						)}
					</div>
					<div
						className="cursor-pointer"
						onClick={() => props.toggleCopyModal()}
					>
						<SVGCross />
					</div>
				</div>
				<div className="flex ">
					<div className="w-1/2 border-r border-[#C8C7C7]">
						<div className="border-b border-[#C8C7C7] flex items-center py-2 px-4 h-10">
							<SVGItem />
							<h4 className="text-[#718096] text-sm ml-2">Items</h4>
						</div>
						<div className="min-h-[250px]">
							{itemsToBeCopied.map((item) => {
								const { title, version, _id } = item;
								return (
									<div
										key={title}
										className="border-[#D4D1D1] rounded-md m-2 p-2 bg-[#F7F7F7] flex justify-between items-center"
									>
										<div>
											<p className="text-[12px] m-0">{title}</p>
											<p className="text-xs m-0">{version}</p>
										</div>
										{itemsToBeCopied.length > 1 && (
											<div
												onClick={() => {
													props.setSelectedItems(
														selectedItems.filter((itemId) => itemId !== _id)
													);
													props.setErrorMessage("");
												}}
												className="w-6 cursor-pointer "
											>
												<SVGCancel />
											</div>
										)}
									</div>
								);
							})}
						</div>
					</div>
					<div className="w-1/2 ">
						<div className="border-b border-[#C8C7C7] flex justify-between items-center py-2 px-4 h-10">
							<div className="flex items-center">
								<SVGTo />
								<h4 className="text-[#718096] text-sm ml-2">To</h4>
							</div>
							{selectedVesselOptions?.length ? (
								<p className="text-sm text-gray-600">
									{" "}
									Selected vessels :{" "}
									<span className="font-medium">
										{selectedVesselOptions?.length}
									</span>{" "}
								</p>
							) : null}
						</div>
						<div className="m-2">
							<Select
								id="tenants"
								isClearable
								isSearchable
								key={"tenants" + selectedTenantOption?.value}
								placeholder={"Search tenants"}
								isDisabled={false}
								unstyled
								value={selectedTenantOption}
								options={tenantOptions}
								onChange={(newValue, actionMeta) => {
									props.setErrorMessage("");
									props.setTenant(newValue ?? undefined);
								}}
								className={classNames("w-full text-sm", {
									"cursor-not-allowed": false,
								})}
								menuPosition="fixed"
								classNames={{
									option: ({ isFocused, isSelected }) =>
										clsx(
											isFocused && optionStyles.focus,
											isSelected && optionStyles.selected,
											optionStyles.base
										),

									dropdownIndicator: () => dropdownIndicatorStyles,
									menu: () => menuStyles,
									clearIndicator: () => clearIndicatorStyles,
									placeholder: () => placeholderStyles,
									control: ({ isFocused, isDisabled }) =>
										clsx(
											isFocused ? controlStyles.focus : controlStyles.nonFocus,
											isDisabled ? controlStyles.disabled : controlStyles.base
										),

									valueContainer: ({ isDisabled }) =>
										clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
								}}
							/>
						</div>
						<div className="m-2">
							<Select
								id="vessels"
								isMulti
								isClearable
								isSearchable
								key={
									"vessels" +
									selectedVesselOptions?.map((vessel) => vessel?.value).join("")
								}
								placeholder={"Search vessels"}
								isDisabled={!selectedTenantOption?.value}
								unstyled
								value={selectedVesselOptions}
								options={vesselsOptions.filter(
									(vesselOption) =>
										vesselOption?.value !== currentVesselDetails?.value
								)}
								isLoading={jobToLoadVesselSpecificToTenant.isLoading}
								onChange={(newValue, actionMeta) => {
									props.setErrorMessage("");
									props.setVessels(
										newValue.map((vessel) => ({
											label: vessel.label,
											value: vessel.value,
										}))
									);
								}}
								className={classNames("w-full text-sm", {
									"cursor-not-allowed": false,
								})}
								menuPosition="fixed"
								classNames={{
									option: ({ isFocused, isSelected }) =>
										clsx(
											isFocused && optionStyles.focus,
											isSelected && optionStyles.selected,
											optionStyles.base
										),
									multiValue: () => multiValueStyles,
									dropdownIndicator: () => dropdownIndicatorStyles,
									menu: () => menuStyles,
									clearIndicator: () => clearIndicatorStyles,
									placeholder: () => placeholderStyles,
									control: ({ isFocused, isDisabled }) =>
										clsx(
											isFocused ? controlStyles.focus : controlStyles.nonFocus,
											isDisabled ? controlStyles.disabled : controlStyles.base
										),

									valueContainer: ({ isDisabled }) =>
										clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
								}}
							/>
						</div>

						<div className="m-2 mt-6">
							<h4 className="text-sm">Get vessels based on Group</h4>
							<div className="mt-2">
								<Select
									id="groups"
									isClearable
									isSearchable
									key={"groups" + selectedGroupOption?.value}
									placeholder={"Search Groups"}
									isDisabled={!selectedTenantOption?.value}
									unstyled
									value={selectedGroupOption}
									options={groupOptions}
									onChange={(newValue, actionMeta) => {
										props.setErrorMessage("");
										const groupId = newValue?.value;
										if (groupId) {
											props.setGroupOption({
												label: groupList.byIds[groupId].groupName,
												value: groupId,
											});
											const groupVessels = groupList.byIds[
												groupId
											]?.vessels?.map((ves) => ({
												label: ves.vesselName,
												value: ves.vesselId,
											}));
											props.setVessels(groupVessels);
										} else {
											props.setVessels([]);
										}

										// props.setTenant(newValue ?? undefined);
									}}
									className={classNames("w-full text-sm", {
										"cursor-not-allowed": false,
									})}
									menuPosition="fixed"
									classNames={{
										option: ({ isFocused, isSelected }) =>
											clsx(
												isFocused && optionStyles.focus,
												isSelected && optionStyles.selected,
												optionStyles.base
											),

										dropdownIndicator: () => dropdownIndicatorStyles,
										menu: () => menuStyles,
										clearIndicator: () => clearIndicatorStyles,
										placeholder: () => placeholderStyles,
										control: ({ isFocused, isDisabled }) =>
											clsx(
												isFocused
													? controlStyles.focus
													: controlStyles.nonFocus,
												isDisabled ? controlStyles.disabled : controlStyles.base
											),

										valueContainer: ({ isDisabled }) =>
											clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
									}}
								/>
							</div>
							<div
								onClick={() => {
									props.toggleCopyModal();
									props.goTo(
										"#groups",
										rootRoutes.children.app.children.tools.children.list.children.groups.url()
									);
								}}
								className="flex justify-end text-sm text-red-500 underline cursor-pointer"
							>
								{!groupOptions?.length && selectedTenantOption?.value
									? "Create group"
									: "Manage groups"}
							</div>
						</div>
					</div>
				</div>
				<div className="border-[#C8C7C7] border-t  p-2">
					<Button
						className={classNames(" w-full bg-blue-700 disabled:bg-gray-300 ", {
							"cursor-not-allowed": jobToCopyConfig.isLoading,
						})}
						onClick={() => {
							props.performCopyOperation(itemsToBeCopied);
						}}
						disabled={
							jobToCopyConfig.isLoading ||
							jobToLoadVesselSpecificToTenant?.isLoading ||
							!selectedVesselOptions?.length
						}
						loading={jobToCopyConfig.isLoading}
					>
						Copy
					</Button>
				</div>
			</div>
		</>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const toolStore = toolSelectors._getStore(store);
	const tenants = toolSelectors.getTenants(toolStore);
	const vessels = toolSelectors.getConfigCopyModalVessels(toolStore);
	const selectedTenantOption =
		toolSelectors.getConfigCopySelectedTenantOption(toolStore);
	const selectedGroupOption =
		toolSelectors.getConfigCopySelectedGroupOption(toolStore);
	const selectedVesselOptions =
		toolSelectors.getConfigCopySelectedVesselOptions(toolStore);
	const jobToLoadVesselSpecificToTenant =
		toolSelectors.jobToLoadVesselsSpecificToTenant(toolStore);

	const currentVesselDetails = toolSelectors.getSelectedVesselOption(toolStore);

	const selectedItems = toolSelectors.getSelectedItems(toolStore);
	const activeTab = toolSelectors.getActiveTabForConfig(toolStore);
	const configIdToBeCopied = toolSelectors.getActionConfigId(toolStore);
	let configList = toolSelectors.getConfigLogsList(toolStore);
	if (activeTab === CONFIG_TABS.TAB_CHECKLISTS) {
		configList = toolSelectors.getConfigChecklistsList(toolStore);
	} else if (activeTab === CONFIG_TABS.TAB_PERMITS) {
		configList = toolSelectors.getConfigPermitsList(toolStore);
	}
	// let itemsToBeCopied = [];
	// if (selectedItems.length) {
	// 	selectedItems.forEach((id) => {
	// 		if (id in configList.byIds) itemsToBeCopied.push(configList.byIds[id]);
	// 	});
	// } else {
	// 	if (configIdToBeCopied in configList.byIds) {
	// 		const config = configList.byIds[configIdToBeCopied];
	// 		itemsToBeCopied.push(config);
	// 	}
	// }

	const errorMessage = toolSelectors.getConfigErrorMessage(toolStore);
	const jobToCopyConfig = toolSelectors.jobToCopyConfig(toolStore);
	const groupList = toolSelectors.getToolGroupsList(toolStore);

	return {
		tenants,
		vessels,
		selectedTenantOption,
		selectedGroupOption,
		selectedVesselOptions,
		jobToLoadVesselSpecificToTenant,
		currentVesselDetails,
		selectedItems,
		configIdToBeCopied,
		configList,
		errorMessage,
		jobToCopyConfig,
		groupList,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {
		toggleCopyModal() {
			dispatch(toolActions.document.copyModalToggle());
		},
		setTenant(tenantOption?: IOption) {
			dispatch(
				toolActions.document.toolConfigCopyTenandOptionSelect(tenantOption)
			);
		},
		setVessels(vesselOptions?: IOption[]) {
			dispatch(
				toolActions.document.toolConfigCopyVesselOptionsSelect(vesselOptions)
			);
		},
		loadTenantSpecificVesselsList(tenantId: string) {
			dispatch(
				toolActions.commands.toolTenantSpecificVesselLoad(
					tenantId,
					"config-copy"
				)
			);
		},
		setActionConfigId(configId: string) {
			dispatch(toolActions.document.toolConfigIdOnActionSelect(configId));
		},
		setSelectedItems(selectedItems: string[]) {
			dispatch(toolActions.document.toolConfigItemsSelect(selectedItems));
		},
		performCopyOperation(itemsToBeCopied: IConfigListItem[]) {
			dispatch(toolActions.commands.toolConfigCopy(itemsToBeCopied));
		},
		setErrorMessage(msg: string) {
			dispatch(toolActions.document.toolConfigErrorMessageSet(msg));
		},
		goTo(reference: string, url: string) {
			dispatch(historyActions.push(reference, url));
		},
		loadGroupsList(tenantId?: string) {
			dispatch(toolActions.commands.toolGroupsListLoad(tenantId));
		},
		setGroupOption(groupOption?: IOption) {
			dispatch(
				toolActions.document.toolConfigCopyGroupOptionSelect(groupOption)
			);
		},
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ConfigCopy);
